var TableName;
(function (TableName) {
    TableName["OFFLINE_DATA"] = "OfflineData";
    TableName["DOCUMENT_DATA"] = "DocumentData";
    TableName["PAD_INFO"] = "PadInfo";
    TableName["NEW_DOCUMENT_ID"] = "NewDocumentIds";
    TableName["FOLDER_INFO"] = "FolderInfo";
    TableName["USER_INFO"] = "UserInfo";
    TableName["DOCUMENT_STATUS"] = "DocumentStatus";
    TableName["LIST_TYPE"] = "ListType";
    TableName["DATA_CHANGE"] = "DataChange";
    TableName["QUICK_LOOK_WORD"] = "QuickLookWord";
    TableName["USERS"] = "Users";
    TableName["DocumentEntities"] = "DocumentEntities";
})(TableName || (TableName = {}));
var DOC_TYPE;
(function (DOC_TYPE) {
    DOC_TYPE["EXCEL"] = "EXCEL";
    DOC_TYPE["WORD"] = "WORD";
    DOC_TYPE["SLIDE"] = "SLIDE";
})(DOC_TYPE || (DOC_TYPE = {}));
var PadIdType;
(function (PadIdType) {
    PadIdType["GLOBAL"] = "globalPadId";
    PadIdType["SECRET"] = "secretId";
})(PadIdType || (PadIdType = {}));
var DB_NAME = 'TencentDocs';
var DB_NAME_TESTENV = 'TencentDocs_TestEnv';
/**
 * 数据库版本号
 */
var DB_VERSION = 4;
var DEBUG = localStorage.getItem('isOfflineModuleDebug') === 'true' || false;
function switchDebug(debug) {
    localStorage.setItem('isOfflineModuleDebug', String(debug));
    DEBUG = debug;
}
export { TableName, PadIdType, DB_NAME, DB_NAME_TESTENV, DB_VERSION, DEBUG, switchDebug, DOC_TYPE, };
//# sourceMappingURL=Constant.js.map